import React, { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { MessageIcon } from '@fiverr-private/icons';
import { translate } from '@fiverr-private/i18n-react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { theme } from '@fiverr-private/theme';
import { useSellerData } from '../../hooks/useSellerData';
import { LanguageCode, LanguageProficiencyLevel } from '../../gql-operations/gql-generated';
import { FederatedSeller } from '../../types';

const getLanguage = (codeName: LanguageCode) => translate(`languages.codes.${codeName.toLowerCase()}`);

interface LanguagesProps {
    textSize?: keyof typeof theme.bodySizes;
    withPrefix?: boolean;
}

export const Languages = ({ textSize = theme.bodySizes.b_md, withPrefix = false }: LanguagesProps) => {
    const { languages } = useSellerData(selectSellerSlice);

    const validLanguages = useMemo(
        () => languages.filter((item) => item.level !== LanguageProficiencyLevel.Basic),
        [languages]
    );

    if (isEmpty(validLanguages)) {
        return null;
    }

    return (
        <Stack gap="1" alignItems="center">
            <MessageIcon size={16} color={theme.colors.grey_1200} />
            <Stack gap="1">
                {withPrefix && (
                    <Text color="bodyPrimary" as="span" size={textSize}>
                        {translate('seller_page_perseus.professions_page.header.speaks')}
                    </Text>
                )}
                <Text color="bodyPrimary" as="span" size={textSize}>
                    {validLanguages.map((lang) => getLanguage(lang.code)).join(', ')}
                </Text>
            </Stack>
        </Stack>
    );
};

function selectSellerSlice(seller: FederatedSeller) {
    return {
        languages: seller.user.languages,
    };
}
